import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/footer.css';

const Footer = () => {
  const { t } = useTranslation();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <div className="footer-logo">
            <img src="/assets/nexus-mark.png" alt="Nexus" className="logo-mark" />
            <div className="logo-text">
              <div className="logo-name">nexus</div>
              <div className="logo-subtitle">AFRICA SOLUTIONS</div>
            </div>
          </div>
          <p className="footer-description">
            Ingénierie IT, réseaux, cybersécurité et développement logiciel. Au service des entreprises et institutions, depuis Yaoundé.
          </p>
          <div className="social-links">
            <a href="#facebook" title="Facebook"><svg width="17" height="17" viewBox="0 0 24 24" fill="#fff"><path d="M22 12a10 10 0 1 0-11.5 9.9v-7H8v-2.9h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.2c-1.2 0-1.6.8-1.6 1.5v1.8H16l-.4 2.9h-2.1v7A10 10 0 0 0 22 12z"/></svg></a>
            <a href="#linkedin" title="LinkedIn"><svg width="17" height="17" viewBox="0 0 24 24" fill="#fff"><path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14zM8.34 18.34V10.1H5.67v8.24h2.67zM7 8.9a1.55 1.55 0 1 0 0-3.1 1.55 1.55 0 0 0 0 3.1zm11.34 9.44v-4.52c0-2.41-1.29-3.53-3-3.53a2.6 2.6 0 0 0-2.35 1.29v-1.1h-2.67v8.24h2.67v-4.36c0-1.15.22-2.26 1.64-2.26s1.41 1.31 1.41 2.33v4.29h2.67z"/></svg></a>
            <a href="#twitter" title="Twitter"><svg width="17" height="17" viewBox="0 0 24 24" fill="#fff"><path d="M18.9 1.2h3.7l-8 9.2 9.4 12.4h-7.4l-5.8-7.6-6.6 7.6H.5l8.6-9.8L0 1.2h7.6l5.2 6.9 6.1-6.9zm-1.3 19.5h2L6.5 3.3h-2.2L17.6 20.7z"/></svg></a>
          </div>
        </div>

        <div className="footer-column">
          <h3>{t('nav.expertises')}</h3>
          <ul>
            <li><a href="#services" onClick={() => scrollToSection('services')}>Infrastructure & Réseaux</a></li>
            <li><a href="#services" onClick={() => scrollToSection('services')}>Cybersécurité</a></li>
            <li><a href="#services" onClick={() => scrollToSection('services')}>Développement logiciel</a></li>
            <li><a href="#services" onClick={() => scrollToSection('services')}>Télécoms & Connectivité</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Entreprise</h3>
          <ul>
            <li><a href="#about" onClick={() => scrollToSection('about')}>{t('nav.about')}</a></li>
            <li><a href="#team" onClick={() => scrollToSection('team')}>{t('nav.team')}</a></li>
            <li><a href="#work" onClick={() => scrollToSection('work')}>{t('nav.realisations')}</a></li>
            <li><a href="#top">Carrières</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>{t('nav.contact')}</h3>
          <div className="contact-info">
            <p>{t('contact.email')}</p>
            <p>{t('contact.phone')}</p>
            <p>{t('contact.address')}</p>
            <a href="#contact" onClick={() => scrollToSection('contact')} className="footer-btn">
              {t('nav.quote')} →
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>&copy; 2026 Nexus Africa Solutions. Tous droits réservés.</span>
        <div className="footer-legal">
          <a href="#top">Mentions légales</a>
          <a href="#top">Confidentialité</a>
          <a href="#top">Cookies</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
